const state = {
  message: null
}

const mutations = {
  SET_MESSAGE: function (state, message) {
    state.message = message;
  },
  
  CLEAR_MESSAGE: function (state) {
    state.message = null;
  }
}

const actions = {
  setMessage({ commit, state }, message) {
    commit('SET_MESSAGE', message)
  },
  clearMessage({ commit, state }) {
    commit('CLEAR_MESSAGE')
  },

}

const getters = {
  getMessage(state) {
    return state.message
  },
}

export default {
  state,
  getters,
  actions,
  mutations
} 



// WEBPACK FOOTER //
// ./src/store/modules/Message.js